import { RootState } from "../index";
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { fetchSender, fetchSenders } from "src/actions/sendgrid/sendersActions";

export interface SenderInterface {
  id: string;
  email: string;
}

export interface initialInterface {
  error: string | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  count: number;
}

const initialState: initialInterface = {
  error: null,
  status: 'idle',
  count: 0
};

const sendersAdapter = createEntityAdapter<SenderInterface>();

const slice = createSlice({
  name: 'senders',
  initialState: sendersAdapter.getInitialState(initialState),
  reducers: {},
  extraReducers: (builder) => {
    builder
      // #index
      .addCase(fetchSenders.pending, (state, _action) => {
        state.status = 'loading'
      })
      .addCase(fetchSenders.fulfilled, (state, action) => {
        state.count = action.payload.count;
        state.entities = action.payload.senders;
        state.ids = action.payload.ids;
        state.status = 'succeeded';
      })
      .addCase(fetchSenders.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Unknown Error';
      })

      // #show
      .addCase(fetchSender.fulfilled, (state, action) => {
        const sender = Object.values(action.payload.sender)[0];
        state.entities[sender.id] = sender;
      })
  }
});

const reducer = slice.reducer;
export default reducer;

export const {
  selectById: selectSenderById,
  selectIds: selectSenderIds,
  selectEntities: selectSenderEntities
} = sendersAdapter.getSelectors<RootState>(state => state.sendgrid.senders);
